<div class="bg-angkor">
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon class="icon-close">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="container" align="center">
    <p class="description">Get your pass fast & easy download the app now</p>
    <p class="underline bold">Available On</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <div class="app-available">
        <img class="link-store playstore" alt="playstore" (click)="_googlePlay()" src="/assets/img/google-play.png">
        <img class="link-store appstore" alt="appstore" (click)="_appStore()" src="/assets/img/app-store.png">
    </div>
</mat-dialog-actions>
<p class="label underline countdown">Auto Close in {{countdown}}s...</p>
